import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Modal } from '@/@bothrs-ui/web/components/modal/Modal'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'

import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type IntramurrosExpiredModalProps = InheritableModalProps

const IntramurrosExpiredModal = ({ ...props }: IntramurrosExpiredModalProps) => {
  const theme = useTheme()

  return (
    <Modal {...props}>
      <FlexColumn alignContent='center'>
        <Margin mt={theme.UI.Spacing.Space5} />

        <H3 textAlign='center' color={theme.Colors.Neutrals.Darkest}>
          {t({
            id: 'notification.intramuros-expired.title',
            comment: 'title for the modal notifying of expired intramuros',
            message: 'Synops token verlopen',
          })}
        </H3>

        <P type='BodyLargeRegular' textAlign='center' color={theme.Colors.Neutrals.Darker}>
          {t({
            id: 'notification.intramuros-expired.body',
            comment: 'body for the modal notifying of expired intramuros',
            message: 'Uw token is verlopen. Vraag een nieuwe synops token aan om verder te gaan.',
          })}
        </P>
      </FlexColumn>
    </Modal>
  )
}

export { IntramurrosExpiredModal }
